module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rootWebinars"
  }, [_c('WebinarsModule', {
    attrs: {
      "isLoading": _vm.isLoading,
      "data": _vm.webinars,
      "errorText": _vm.errorText,
      "paginator-data": _vm.paginatorData
    }
  }), (_vm.showSferumBlock) ? _c('div', {
    staticClass: "vkRoot"
  }, [(this.vkAuth === false) ? _c('AppButtonNew', {
    attrs: {
      "disabled": _vm.vkAuthing
    },
    on: {
      "click": _vm.goToVk
    }
  }, [_vm._v("Войти в Сферум")]) : (this.vkAuth === true) ? _c('AppButtonNew', {
    attrs: {
      "color": "red"
    },
    on: {
      "click": _vm.disconnect
    }
  }, [_vm._v("Выйти из Сферума")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b7efe4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/views/webinars/Webinars.vue
// module id = 19b60da85a2f35032384
// module chunks = 14